<template>
  <div class="deck" :class="{ 'deck--shuffle': shuffling }" :title="`${count} cards left in the deck`">
    <div class="deck__stack">
      <span v-for="n in layers" :key="n" class="deck__card" :style="{ '--i': n - 1 }"><span class="deck__mark">✦</span></span>
      <span v-if="fly" :key="fly.key" class="deck__card deck__card--fly" :class="`deck__card--${fly.kind}`"><span class="deck__mark">✦</span></span>
    </div>
    <span class="deck__count">{{ count }}</span>
    <span class="deck__label">{{ count === 1 ? 'card left' : 'cards left' }}</span>
  </div>
</template>

<script>
// The deck, as a thing on the table: a stack you can see shrink, that
// visibly takes a card when an action seeds one (it slides in and the
// stack shuffles) and gives one up when the world turns (the top card
// lifts off toward the stage). Playtest 2 asked for exactly this.
export default {
  name: 'DeckStack',
  props: {
    count: { type: Number, required: true },
  },
  data() { return { fly: null, shuffling: false, flyKey: 0, timers: [] }; },
  computed: {
    layers() { return Math.max(1, Math.min(5, Math.ceil(this.count / 3))); },
  },
  watch: {
    count(now, was) {
      if (now > was) this.animate('in');
      else if (now < was) this.animate('out');
    },
  },
  beforeUnmount() { this.timers.forEach((t) => window.clearTimeout(t)); },
  methods: {
    animate(kind) {
      this.flyKey += 1;
      this.fly = { kind, key: this.flyKey };
      const gone = window.setTimeout(() => { if (this.fly?.key === this.flyKey) this.fly = null; }, 900);
      this.timers.push(gone);
      if (kind === 'in') {
        this.shuffling = false;
        const on = window.setTimeout(() => { this.shuffling = true; }, 500);
        const off = window.setTimeout(() => { this.shuffling = false; }, 1300);
        this.timers.push(on, off);
      }
    },
  },
};
</script>
